import { ReactNode, useContext } from "react";
import { SessaoContext } from "../../../Contexts/SessaoContext";
import { PermissoesKey, PermissoesKeyType } from "../../../Constants/Permissoes";

export interface IPermissaoProps {
    permissoes:Array<keyof PermissoesKeyType>;
    /**
     * @default "all"
     */
    tipo?:"all"|"any";
}
export interface IComponentePermissaoProps extends IPermissaoProps {
    children:ReactNode;
    isRenderizarNaoPermitido?:boolean;
    renderNaoPermitido?:ReactNode;
}

export function usePermitido({
    permissoes,
    tipo
}:IPermissaoProps) {
    tipo = tipo ?? "all";

    const sessao = useContext(SessaoContext);
    const allPermissao = tipo === "all" && permissoes.every(all => sessao?.sessao?.usuario?.permissoes?.some(any => any.nome === PermissoesKey[all]));
    const anyPermissao = tipo === "any" && permissoes.some(anyP => sessao?.sessao?.usuario?.permissoes?.some(any => any.nome === PermissoesKey[anyP]));

    const permitido = (tipo === "all" && allPermissao) || (tipo === "any" && anyPermissao);

    return {
        permitido
    };
}

export default function ComponentePermissao ({
    permissoes,
    tipo,
    renderNaoPermitido,
    children
}:IComponentePermissaoProps) {
    renderNaoPermitido = renderNaoPermitido ?? <></>;
    
    const {
        permitido
    } = usePermitido({
        permissoes,
        tipo
    });

    return permitido && children || renderNaoPermitido;
}